/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostRestrictedModelsPathParams = NonNullable<operations['postRestrictedModels']['parameters']['path']>;

export type PostRestrictedModelsRequestBody = OperationRequestBodyContent<operations['postRestrictedModels']>;

export interface Input extends PostRestrictedModelsPathParams {
  apiVersion?: string;
  body: PostRestrictedModelsRequestBody;
}

export async function postRestrictedModels(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/ai-configs/model-configs/restricted', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
